module.exports = __webpack_public_path__ + "static/media/pers_schutz_all_true_active.28b11746.jpg";